import { useCandidateAuth } from 'features/auth';
import { CandidateAccessTokenConfig } from 'features/auth/types';
import { useTenantContext } from 'shared/contexts';
import { AccessLimitFilter, Tenant } from 'shared/types';

export default function useAccessFilterCheck(filter: AccessLimitFilter) {
    const tenant = useTenantContext();
    const { accessToken } = useCandidateAuth();

    return satisfyFeatureFlagFilter(filter, tenant) &&
           satisfyFullAccessFilter(filter, accessToken);
}

function satisfyFeatureFlagFilter(filter: AccessLimitFilter, tenant: Tenant) {
    return !filter.feature || Boolean(tenant?.featuresEnabled?.[filter.feature]);
}

function satisfyFullAccessFilter(filter: AccessLimitFilter, accessToken: CandidateAccessTokenConfig) {
    return !filter.fullAccessRequired || accessToken.fullAccess;
}
